/* Apple-style progressive configurator gating for AMPD product pages.
   Frame is always active. Colour unlocks once a Frame is chosen; Configure
   unlocks once a Colour is chosen; Build your kit unlocks once Configure is
   chosen. Locked steps are dimmed and made inert. Only runs when frame cards
   are present (the AMPD templates).

   With data-config-hide="on" the later steps are removed from the layout
   rather than dimmed until frame + colour are chosen. Dimming still reserves
   their height, which pushed Add to Cart - and the Notify Me button on a
   sold-out variant - well below the fold before the shopper had done
   anything. */
(function () {
  function q(sel) { return document.querySelector(sel); }

  function setHidden(els, hidden) {
    Array.prototype.forEach.call(els, function (el) {
      if (!el) return;
      el.classList.toggle('pdp-step-hidden', hidden);
      el.classList.remove('pdp-prehide'); // the controller owns it from here
    });
  }

  // Whatever happens, never leave a block stuck behind the no-flash pre-hide.
  function revealPrehidden() {
    Array.prototype.forEach.call(document.querySelectorAll('.pdp-prehide'), function (el) {
      el.classList.remove('pdp-prehide');
    });
  }

  function setLock(els, locked) {
    Array.prototype.forEach.call(els, function (el) {
      if (!el) return;
      el.classList.toggle('pdp-step-locked', locked);
      try { el.inert = locked; } catch (e) { /* older browsers: class handles it */ }
    });
  }

  function run() {
    // Templates can opt out entirely (see main-product's "Dim later options"
    // setting). Bail before anything is dimmed rather than un-dimming after,
    // which would flash.
    if (document.querySelector('[data-config-gating="off"]')) {
      Array.prototype.forEach.call(document.querySelectorAll('.pdp-gated'), function (el) {
        el.classList.remove('pdp-gated');
      });
      revealPrehidden();
      // Gating off: nothing is ever locked, so colour is always available.
      var vpOff = q('variant-picker');
      if (vpOff) vpOff.classList.add('is-frame-chosen');
      Array.prototype.forEach.call(document.querySelectorAll('.pdp-step-locked'), function (el) {
        el.classList.remove('pdp-step-locked');
        try { el.inert = false; } catch (e) {}
      });
      return;
    }

    var hideSteps = !!document.querySelector('[data-config-hide="on"]');

    // Gate when there's something to gate. On models with no Frame option,
    // Colour becomes the first step (frame step treated as satisfied).
    if (!q('.option-selector--frame') && !q('.custom-option__cards') && !q('.pu2')) {
      revealPrehidden();
      return;
    }

    function update() {
      var hasFrame = !!q('.option-selector--frame');
      var frameOk = hasFrame ? !!q('.option-selector--frame .opt-btn:checked') : true;

      // Colour = any variant option that isn't the frame.
      var colourEls = document.querySelectorAll(
        'variant-picker .option-selector:not(.option-selector--frame)'
      );
      var colourOk = (colourEls.length === 0) ||
        Array.prototype.every.call(colourEls, function (fs) {
          return !!fs.querySelector('.opt-btn:checked');
        });

      // Configure = the cards-style custom option block (if present).
      var cards = q('.custom-option__cards');
      var cfgBlock = cards ? cards.closest('.product-info__block') : null;
      var cfgOk = cfgBlock ? !!cfgBlock.querySelector('input:checked') : true;

      // Build your kit = Popular Upgrades V2 block (if present).
      var kit = q('.pu2');
      var kitBlock = kit ? (kit.closest('.product-info__block') || kit) : null;

      // Colour is hidden via CSS until a frame is chosen; reveal with a class.
      // With no Frame option, colour isn't hidden (CSS :has guard) — reveal anyway.
      var vp = q('variant-picker');
      // Colour is shown dimmed until a frame is chosen (CSS handles the
      // dimming off this class). inert as well as pointer-events, so it can't
      // be reached by keyboard or read as available by a screen reader while
      // it's locked.
      if (vp) vp.classList.toggle('is-frame-chosen', !hasFrame || frameOk);
      if (hasFrame && colourEls.length) setLock(colourEls, !frameOk);

      var configured = frameOk && colourOk;
      if (hideSteps) {
        // Both later steps appear together, the moment the bike itself is
        // chosen. Hiding is instead of dimming, not as well as it, so nothing
        // reappears already greyed out.
        setHidden([cfgBlock, kitBlock], !configured);
        if (cfgBlock) setLock([cfgBlock], false);
        if (kitBlock) setLock([kitBlock], configured ? !cfgOk : false);
      } else {
        if (cfgBlock) setLock([cfgBlock], !configured);
        if (kitBlock) setLock([kitBlock], !(configured && cfgOk));
      }
    }

    // The controller now owns the lock state — drop the server-side pre-dim
    // placeholder so it doesn't double up with .pdp-step-locked.
    Array.prototype.forEach.call(document.querySelectorAll('.pdp-gated'), function (el) {
      el.classList.remove('pdp-gated');
    });
    loadProduct(function () {}); // warm the cache for the frame-hero image swap

    document.addEventListener('change', update);
    document.addEventListener('on:variant:change', update);
    update();
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  /* When a Frame is chosen but no Colour is selected yet, the gallery can't
     resolve a full variant, so it doesn't update. Workaround: display (don't
     select) the hero/first colour group so the bike image shows on frame pick. */
  var productJson = null; // null = not loaded, false = failed
  function loadProduct(cb) {
    if (productJson !== null) return cb(productJson || null);
    var vp = q('variant-picker');
    var url = vp && vp.getAttribute('data-url');
    if (!url) { productJson = false; return cb(null); }
    fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { productJson = p; cb(p); })
      .catch(function () { productJson = false; cb(null); });
  }

  function showFrameHero() {
    var g = q('media-gallery');
    if (!g || typeof g.setActiveMediaGroup !== 'function') return;
    var frameFs = q('.option-selector--frame');
    var checked = frameFs && frameFs.querySelector('.opt-btn:checked');
    var frameVal = checked ? checked.value : null;

    function heroFallback() {
      try {
        var groups = g.getMediaGroupMap().groups;
        var first = groups && Object.keys(groups)[0];
        if (first) g.setActiveMediaGroup(first, true);
      } catch (e) { /* no-op */ }
    }
    if (!frameVal) return heroFallback();

    loadProduct(function (p) {
      if (!p || !p.variants) return heroFallback();
      var frameName = (frameFs.getAttribute('data-option') || 'Frame');
      var idx = (p.options || []).indexOf(frameName);
      if (idx < 0) idx = 0;
      var variant = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available && p.variants[i].options[idx] === frameVal) { variant = p.variants[i]; break; }
      }
      if (!variant) {
        for (var j = 0; j < p.variants.length; j++) {
          if (p.variants[j].options[idx] === frameVal) { variant = p.variants[j]; break; }
        }
      }
      if (!variant) return heroFallback();
      var data = (typeof g.getMediaGroupData === 'function') ? g.getMediaGroupData() : null;
      var map = data && data.variantFeaturedMedia;
      var mediaId = map && map[String(variant.id)];
      if (mediaId) g.setActiveMediaGroup(String(mediaId));
      else heroFallback();
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('.option-selector--frame')) return;
    // Only while no colour is chosen — once a colour is picked, leave the gallery alone.
    if (document.querySelector('variant-picker .option-selector:not(.option-selector--frame) .opt-btn:checked')) return;
    setTimeout(showFrameHero, 0);
  });

  /* Keep the buy-box stock status in sync with the selected variant. With
     auto-select off the server renders it from the product's overall stock;
     once a variant is chosen we reflect that variant's availability. */
  document.addEventListener('on:variant:change', function (e) {
    var stock = q('[data-ampd-stock]');
    if (!stock) return;
    var v = e.detail && e.detail.variant;
    // No complete variant yet → stay in-stock (don't cry "out of stock").
    var available = v ? !!v.available : true;
    stock.classList.toggle('is-out', !available);
    var h = stock.querySelector('.ampd-buybox__stock-h');
    var s = stock.querySelector('.ampd-buybox__stock-s');
    if (h) h.textContent = available ? stock.dataset.inHeading : stock.dataset.outHeading;
    if (s) s.textContent = available ? stock.dataset.inSub : stock.dataset.outSub;
  });

  /* Add to Cart (main or sticky) with an earlier step unmet: instead of letting
     the form submit and land native validation on a lower required field, scroll
     up to the FIRST unmet step and pulse it to prompt a selection. */
  function configFlowActive() {
    return !!(q('.option-selector--frame') || q('.custom-option__cards'));
  }
  function firstUnmetStep() {
    if (q('.option-selector--frame') && !q('.option-selector--frame .opt-btn:checked')) {
      return { el: q('.option-selector--frame'), label: 'a frame' };
    }
    var colourEls = document.querySelectorAll('variant-picker .option-selector:not(.option-selector--frame)');
    for (var i = 0; i < colourEls.length; i++) {
      if (!colourEls[i].querySelector('.opt-btn:checked')) {
        var lbl = colourEls[i].querySelector('.option-selector__label, legend, .form__label');
        var name = lbl ? lbl.textContent.replace(/[:*]/g, '').trim().toLowerCase() : 'an option';
        return { el: colourEls[i], label: 'a ' + name };
      }
    }
    var cards = q('.custom-option__cards');
    if (cards && !cards.querySelector('input:checked')) {
      return { el: cards.closest('.product-info__block') || cards, label: 'a configuration' };
    }
    return null;
  }
  function showPrompt(label) {
    var t = document.getElementById('pdp-step-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'pdp-step-toast';
      t.className = 'pdp-step-toast';
      t.setAttribute('role', 'alert');
      document.body.appendChild(t);
    }
    t.textContent = 'Please choose ' + label + ' to continue';
    // force reflow so the transition re-runs if it's already visible
    void t.offsetWidth;
    t.classList.add('is-visible');
    clearTimeout(showPrompt._t);
    showPrompt._t = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }
  function scrollToStep(step) {
    if (!step || !step.el) return;
    step.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    step.el.classList.add('pdp-step-attention');
    setTimeout(function () { step.el.classList.remove('pdp-step-attention'); }, 1800);
    showPrompt(step.label);
  }
  /* Tapping a locked colour on mobile sends you to the frame step.

     On mobile the colour row sits above the frame toggle, so it's the first
     control a shopper reaches - and until a frame is picked it's dimmed and
     inert, which on a phone just reads as "nothing happened". This takes that
     tap and answers it: scroll to the frame, pulse it, say why.

     The locked row has pointer-events: none, so the click never lands on it -
     it passes through to an ancestor. Hence hit-testing the pointer against
     the row's box rather than looking at the event target. Keyboard-triggered
     clicks report 0,0 and simply won't match, which is correct: the row is
     inert, so it can't be focused or activated that way in the first place. */
  function isPhone() {
    return window.matchMedia('(max-width: 768.98px)').matches;
  }

  document.addEventListener('click', function (e) {
    if (!isPhone() || !configFlowActive()) return;
    var frame = q('.option-selector--frame');
    if (!frame || frame.querySelector('.opt-btn:checked')) return;

    var cols = document.querySelectorAll(
      'variant-picker .option-selector:not(.option-selector--frame)'
    );
    for (var i = 0; i < cols.length; i++) {
      var r = cols[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        e.preventDefault();
        scrollToStep({ el: frame, label: 'a frame' });
        return;
      }
    }
  }, true);

  // Only the MAIN bike Add-to-Cart (and the sticky bar, which submits the same
  // form) is subject to the configuration gate — upsells like "AMPD Make It
  // Yours" submit their own forms and must add freely.
  function isMainAtc(btn) {
    var mainForm = document.querySelector('.js-product-form-main');
    return !!(btn && mainForm && btn.form === mainForm);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[name="add"]') : null;
    if (!btn || !configFlowActive() || !isMainAtc(btn)) return;
    var unmet = firstUnmetStep();
    if (unmet) {
      e.preventDefault();
      e.stopPropagation();
      scrollToStep(unmet);
    }
  }, true);

  /* Keep the Add to Cart buttons (main + sticky) greyed out until EVERY
     essential step is chosen (colour, configuration, and frame where present).
     The theme un-greys the button as soon as a variant resolves — but a
     configuration is a required custom option the theme doesn't know about, so
     we re-lock the button here. Buttons stay clickable so the click handler
     above can still scroll to + prompt the missing step. */
  function gateButtons() {
    if (!configFlowActive()) return;
    var locked = !!firstUnmetStep();
    document.querySelectorAll('button[name="add"]').forEach(function (btn) {
      if (!isMainAtc(btn)) return; // leave upsell add-to-cart buttons alone
      btn.classList.toggle('pdp-atc-gated', locked);
      if (locked) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }
  // Re-evaluate on any selection change (colour/frame fire variant change too).
  document.addEventListener('on:variant:change', function () { setTimeout(gateButtons, 0); });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.custom-option, variant-picker, .option-selector')) gateButtons();
  });
  // The theme re-renders the button on variant change — re-apply the gate when
  // the buy-buttons area mutates so our grey state survives the swap.
  function watchButtons() {
    var host = q('product-form') || q('.product-info__form') || document.body;
    new MutationObserver(function () { gateButtons(); })
      .observe(host, { childList: true, subtree: true });
    gateButtons();
  }
  if (document.readyState !== 'loading') watchButtons();
  else document.addEventListener('DOMContentLoaded', watchButtons);

  /* Self-contained "Learn more" pop-up (no theme modal system, no navigation).
     The button has no href so it can never navigate; this opens our own modal
     which is populated server-side with the linked page's content. */
  function openConfigModal(m) {
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    document.documentElement.classList.add('config-modal-open');
    var d = m.querySelector('.config-modal__dialog');
    if (d) d.focus();
  }
  function closeConfigModal(m) {
    m.classList.remove('is-open');
    document.documentElement.classList.remove('config-modal-open');
    setTimeout(function () { m.hidden = true; }, 250);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-config-modal-open]') : null;
    if (opener) {
      e.preventDefault();
      var m = document.getElementById(opener.getAttribute('data-config-modal-open'));
      if (m) openConfigModal(m);
      return;
    }
    var closer = e.target.closest ? e.target.closest('[data-config-modal-close]') : null;
    if (closer) {
      var mm = closer.closest('.config-modal');
      if (mm) closeConfigModal(mm);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.config-modal.is-open');
      if (open) closeConfigModal(open);
    }
  });

  /* Hero feature-icon mobile slider: arrows scroll the icon row by one page
     (two icons at a time), plus autoplay every 3.5s. The media region can be
     re-rendered after load (variant/media components), which detaches any node
     captured at init — so always query the current row fresh. */
  function pmRowNow() {
    var s = document.querySelector('.pm-icons-scope');
    return s ? s.querySelector('.product-media__icons') : null;
  }
  // scroll-snap: x mandatory cancels native behavior:'smooth' (it snaps back to
  // the current point mid-animation), so tween scrollLeft ourselves with snap
  // temporarily off, then restore it once we've landed on the exact snap point.
  var pmAnim = 0;
  function pmSmoothTo(row, target) {
    var start = row.scrollLeft;
    var dist = target - start;
    if (!dist) return;
    var mine = ++pmAnim; // invalidate any tween already running on this row
    row.style.scrollSnapType = 'none'; // inline snap is only ever set by us
    var t0 = null, dur = 320;
    function step(ts) {
      if (mine !== pmAnim) return; // superseded by a newer tween
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; // easeInOutQuad
      row.scrollLeft = start + dist * e;
      if (p < 1) { requestAnimationFrame(step); }
      else { row.scrollLeft = target; row.style.scrollSnapType = ''; } // restore CSS snap
    }
    requestAnimationFrame(step);
  }
  var pmTimer = null;
  function pmAdvance() {
    var row = pmRowNow();
    if (!row) return;
    if (row.scrollWidth <= row.clientWidth + 4) return; // not a slider at this width
    var next = row.scrollLeft + row.clientWidth;
    if (next >= row.scrollWidth - 4) next = 0; // loop back to the first set
    pmSmoothTo(row, next);
  }
  function pmStart() { pmStop(); pmTimer = setInterval(pmAdvance, 3500); }
  function pmStop() { if (pmTimer) { clearInterval(pmTimer); pmTimer = null; } }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest ? e.target.closest('.pm-icons__arrow') : null;
    if (!arrow) return;
    var scope = arrow.closest('.pm-icons-scope');
    var row = (scope && scope.querySelector('.product-media__icons')) || pmRowNow();
    if (!row) return;
    var dir = arrow.classList.contains('pm-icons__arrow--next') ? 1 : -1;
    var maxScroll = row.scrollWidth - row.clientWidth;
    var target;
    if (dir > 0) { // next: wrap to the start once past the last page
      target = (row.scrollLeft >= maxScroll - 4) ? 0 : Math.min(row.scrollLeft + row.clientWidth, maxScroll);
    } else { // prev: wrap to the last page from the start
      target = (row.scrollLeft <= 4) ? maxScroll : Math.max(row.scrollLeft - row.clientWidth, 0);
    }
    pmSmoothTo(row, target);
    pmStart(); // restart the timer so it doesn't jump right after a manual tap
  });
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest && e.target.closest('.pm-icons-scope')) pmStop();
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (e.target.closest && e.target.closest('.pm-icons-scope')) pmStart();
  }, { passive: true });
  pmStart();
})();
